// Shared once-per-page logic for product cards: mounts the Glide carousel inside
// each card and wires the 4/8 (desktop) and 1/2 (mobile) column toggle (#grid-1/#grid-2).
// Loaded via a deduplicated `type="module"` tag from snippets/card-product-media.liquid,
// so the body runs exactly once even though the snippet renders per card.
// Glide comes from the local UMD bundle loaded in layout/theme.liquid (window.Glide) —
// no external CDN.

const glideMap = new Map();
const options = {
  type: 'slider',
  perView: 1,
  gap: '0px',
  animationTimingFunc: 'cubic-bezier(.28,.64,.27,1.08)',
  animationDuration: 300,
};

function initGlides() {
  document.querySelectorAll('.glide.card__media').forEach((el) => {
    // Skip carousels we already mounted, or ones mounted elsewhere (e.g. global.js
    // for product recommendations) — Glide marks a mounted root with `glide--slider`.
    if (glideMap.has(el) || el.classList.contains('glide--slider')) return;

    const slides = el.querySelectorAll('.glide__slide');
    if (slides.length <= 1) return;

    if (!window.Glide) return;
    const g = new window.Glide(el, options);
    g.mount();
    glideMap.set(el, g);
  });
}

function destroyGlides() {
  glideMap.forEach((g) => {
    try {
      g.destroy();
    } catch (_) {}
  });
  glideMap.clear();
}

function rebuildGlides() {
  destroyGlides();
  requestAnimationFrame(() => requestAnimationFrame(initGlides));
}

// Grid preference (desktop: 4/8, mobile: 1/2). No persistence: on load / after AJAX
// the server markup (desktop = 4, large cards) is kept, so nothing jumps. The toggle
// only applies within the session.
function applyGrid(pref) {
  const desktop = window.innerWidth >= 990;
  const grid = document.querySelector('#product-grid');

  if (grid) {
    const isCompact = pref === 'compact';

    // Only touch the current breakpoint's classes so the other breakpoint is preserved.
    if (desktop) {
      grid.classList.toggle('grid--4-col-desktop', isCompact);
      grid.classList.toggle('grid--8-col-desktop', !isCompact);
    } else {
      grid.classList.toggle('grid--1-col-tablet-down', isCompact);
      grid.classList.toggle('grid--2-col-tablet-down', !isCompact);
    }

    document.querySelector('#grid-1')?.classList.toggle('active', isCompact);
    document.querySelector('#grid-2')?.classList.toggle('active', !isCompact);
  }

  rebuildGlides();
}

// Idempotent binding: #grid-1/#grid-2 live outside #ProductGridContainer and survive
// AJAX facet re-renders, so the dataset flag guards against stacking duplicate
// listeners on repeated UpdateAll calls.
function bindToggle(btn, pref) {
  if (!btn || btn.dataset.gridToggleBound) return;
  btn.dataset.gridToggleBound = '1';
  btn.addEventListener('click', () => applyGrid(pref));
}

function UpdateAll() {
  initGlides();
  bindToggle(document.querySelector('#grid-1'), 'compact');
  bindToggle(document.querySelector('#grid-2'), 'roomy');
}

window.addEventListener('DOMContentLoaded', UpdateAll);

let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(rebuildGlides, 150);
});

// Re-initialize after AJAX facet filtering (called from assets/facets.js).
window.updateProductGrid = UpdateAll;
